import { Text, TextProps } from "@chakra-ui/react"

export default function Paragraph(props: TextProps) {
  return (
    <Text my={{ base: 2 }} {...props}>
      {props.children}
    </Text>
  )
}
